export default __webpack_public_path__ + "static/media/el_uslugi_main_vertical.f405d1c6.png";